import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicSession } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const endSessionForEveryone = async (
  sessionId: string,
): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/disconnect-everyone`,
  );
  return response.data;
};

function useEndSessionForEveryone(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, string>
  >,
) {
  return useMutation({
    mutationFn: (sessionId) => endSessionForEveryone(sessionId),
    ...mutationOptions,
  });
}

export { useEndSessionForEveryone };
